import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap, map, first, filter } from 'rxjs/operators';
import { Municipality, MunicipalityService, MunicipalityView } from '@app/shared/services/api/municipality.service';
import { flattenDeep } from 'lodash';
import { RegionManagementDataService } from './region-management-data.service';
import { MunicipalityRegionHierarchy } from '@app/shared/services/api/region-municipalities.service';

@Injectable({
  providedIn: 'root',
})
export class ReassignKamService {
  constructor(private municipality: MunicipalityService, private regionManagementData: RegionManagementDataService) {}

  private municipalityStore: BehaviorSubject<Municipality[]> = new BehaviorSubject<Municipality[]>([]);
  public municipalities$ = this.municipalityStore.asObservable();

  public getMunicipalities = (primaryAdminGuid: string) =>
    this.getMunicipalitiesByAdminGuid(primaryAdminGuid).pipe(tap((m: Municipality[]) => this.municipalityStore.next(m)));

  private getMunicipalitiesByAdminGuid = (userGuid: string) => this.municipality.getByPrimaryKAM(userGuid);

  reassignMunicipalitiesToKam = (municipalities: Municipality[], kam: any) => {
    return this.municipality
      .updatePrimaryKAMofMunicipalities(
        municipalities.map((m: Municipality) => m.municipalityKey),
        kam.guid
      )
      .pipe(
        map((x: any[]) => flattenDeep(x)),
        tap((x: any[]) => x.forEach((municipality) => this.updateRegionMunicipality(municipality, kam))),
        tap((x: any[]) => this.updateMunicipalities(x))
      );
  };

  updateMunicipalities = (municipalities: any[]) => {
    municipalities.forEach((x: any) => {
      this.regionManagementData
        .getMunicipality(x.guid)
        .pipe(
          filter((municipality?: MunicipalityView): municipality is MunicipalityView => !!municipality),
          map((municipality: MunicipalityView) => {
            municipality.primaryAdminGuid = x.primaryAdminGuid;
          }),
          first()
        )
        .subscribe();
    });
  };

  private updateRegionMunicipality = (municipality: Municipality, kam: any) => {
    this.regionManagementData
      .getRegionMunicipalityById(municipality.guid)
      .pipe(first())
      .subscribe((regionMunicipality?: MunicipalityRegionHierarchy) => {
        if (!!regionMunicipality) {
          regionMunicipality.primaryAdminFirstName = kam.firstname;
          regionMunicipality.primaryAdminLastName = kam.lastname;
          regionMunicipality.primaryAdminGuid = kam.guid;
        }
      });
  };
}
